import React, { useState } from "react";
import PersonalLinear from "./Charts/PersonalLinear";
import TeamBars from "./Charts/TeamBars";
import GrayToGoldLinear from "./Charts/GrayToGoldLinear";
import { Link } from "react-router-dom";
import OfflineColumnChart from "../HVI/OfflineColumnChart";
import OfflinePieChart from "../HVI/OfflinePieChart";
import { useTranslation } from "react-i18next";
import TeamDataColumnChart from "../Organization/TeamDataColumnChart";
//import Exporting from 'highcharts/modules/exporting';

const OviChart = (props) => {

  const [selectedOviItem, setSelectedOviItem] = useState(0);
  const [translation] = useTranslation("translations");

  if (!props.ovi) {
    return <div className="hvi-chart-wrap mt-3"></div>;
  }

  const getWeekNumber = (date) => {

    if ( ! date ) return;

    const currentDate = new Date(date);
    const startDate = new Date(currentDate.getFullYear(), 0, 1);
    const days = Math.floor((currentDate - startDate) /
        (24 * 60 * 60 * 1000));
         
    const weekNumber = Math.ceil(days / 7);

    return weekNumber;

  }

  let dates = [];
  let oviValues = [];
  let teamOvi = {
    red: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    yellow: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    green: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  };
  let teamDates = [];
  let teamOviSummaryData = [];
  let teamWeeks = [];
  let teamOviWeeklySummaryData = [];

  if (props.ovi.personal && props.ovi.personal.length > 0) {
    dates = props.ovi.personal.map((oviData) => {
      oviValues.push(oviData.ovi_count);

      return oviData.date;
    });
  }

  if (props.ovi.organization && props.ovi.organization.length > 0) {
    props.ovi.organization.map((userdata) => {
      userdata.member_ovi.data.map((ovidata, index) => {
        if (index < 12) {
          if ( ovidata.value === 0 || ovidata.value === 1 || ovidata.value === 2 ) {
            teamOvi.red[index] = teamOvi.red[index] + 1;
          }

          if (ovidata.value === 3 || ovidata.value === 4) {
            teamOvi.yellow[index] = teamOvi.yellow[index] + 1;
          }

          if (ovidata.value === 5 || ovidata.value === 6) {
            teamOvi.green[index] = teamOvi.green[index] + 1;
          }
        }

        return ovidata;
      });

      if (userdata.member_ovi_all && userdata.member_ovi_all.length > 0) {
        userdata.member_ovi_all.map((allOvi) => {
          
          //console.log( getWeekNumber(allOvi.date) );

          const dateWeek = getWeekNumber(allOvi.date);

          if ( ! teamWeeks.includes( dateWeek ) ) {

            let teamOviWeeklyFiltered = {
              red: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              yellow: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              green: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            };

            let red = 0;
            let yellowOne = 0;
            let yellowTwo = 0;
            let green = 0;

            allOvi.data.map((ovidata, index) => {
              if (index < 12) {

                if ( ovidata.value === 0 || ovidata.value === 1 || ovidata.value === 2 ) {
                  teamOviWeeklyFiltered.red[index] = teamOviWeeklyFiltered.red[index] + 1;
                }

                if (ovidata.value === 3 || ovidata.value === 4) {
                  teamOviWeeklyFiltered.yellow[index] = teamOviWeeklyFiltered.yellow[index] + 1;
                }

                if (ovidata.value === 5 || ovidata.value === 6) {
                  teamOviWeeklyFiltered.green[index] = teamOviWeeklyFiltered.green[index] + 1;
                }
              }

              return ovidata;
            });

            if ( allOvi.ovi_count > 12 && allOvi.ovi_count <= 24 ) {
              red = red + 1;
            }

            if ( allOvi.ovi_count > 24 &&  allOvi.ovi_count <= 41 ) {
                yellowOne = yellowOne + 1; 
            }

            if ( allOvi.ovi_count >= 60 ) {
                green = green + 1;
            }

            if ( allOvi.ovi_count >= 42 &&  allOvi.ovi_count <= 59 ) {
                yellowTwo = yellowTwo + 1;
            }

            teamWeeks.push( dateWeek );

            const yearDate = new Date( allOvi.date );
            
            teamOviWeeklySummaryData.push({
              week: dateWeek,
              date: allOvi.date,
              year: yearDate?.getFullYear(),
              ovival: allOvi.ovi_count,
              items: 1,
              ovi_sum: teamOviWeeklyFiltered,
              red: red,
              yellow_one: yellowOne,
              yellow_two: yellowTwo,
              green: green,
            });

          } else {

            teamOviWeeklySummaryData.find((o, i) => {
              if ( o.week === dateWeek ) {
                const items = teamOviWeeklySummaryData[i].items + 1;
                const oviVal = teamOviWeeklySummaryData[i].ovival + allOvi.ovi_count;

                let teamOviWeeklyFiltered = teamOviWeeklySummaryData[i].ovi_sum;

                let red = teamOviWeeklySummaryData[i].red;
                let yellowOne = teamOviWeeklySummaryData[i].yellow_one;
                let yellowTwo = teamOviWeeklySummaryData[i].yellow_two;
                let green = teamOviWeeklySummaryData[i].green;

                allOvi.data.map((ovidata, index) => {
                  if (index < 12) {

                    if ( ovidata.value === 0 || ovidata.value === 1 || ovidata.value === 2 ) {
                      teamOviWeeklyFiltered.red[index] = teamOviWeeklyFiltered.red[index] + 1;
                    }

                    if (ovidata.value === 3 || ovidata.value === 4) {
                      teamOviWeeklyFiltered.yellow[index] =
                        teamOviWeeklyFiltered.yellow[index] + 1;
                    }

                    if (ovidata.value === 5 || ovidata.value === 6) {
                      teamOviWeeklyFiltered.green[index] =
                        teamOviWeeklyFiltered.green[index] + 1;
                    }
                  }

                  return ovidata;
                });

                if ( allOvi.ovi_count > 12 && allOvi.ovi_count <= 24 ) {
                  red = red + 1;
                }
    
                if ( allOvi.ovi_count > 24 &&  allOvi.ovi_count <= 41 ) {
                    yellowOne = yellowOne + 1; 
                }
    
                if ( allOvi.ovi_count >= 60 ) {
                    green = green + 1;
                }
    
                if ( allOvi.ovi_count >= 42 &&  allOvi.ovi_count <= 59 ) {
                    yellowTwo = yellowTwo + 1;
                }

                teamOviWeeklySummaryData[i].ovival = oviVal;
                teamOviWeeklySummaryData[i].items = items;
                teamOviWeeklySummaryData[i].ovi_sum = teamOviWeeklyFiltered;
                teamOviWeeklySummaryData[i].red = red;
                teamOviWeeklySummaryData[i].yellow_one = yellowOne;
                teamOviWeeklySummaryData[i].yellow_two = yellowTwo;
                teamOviWeeklySummaryData[i].green = green;

                return true; // stop searching
              }

              return false;
            });

          }

          if (!teamDates.includes(allOvi.date)) {
            let teamOviFiltered = {
              red: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              yellow: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              green: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            };

            allOvi.data.map((ovidata, index) => {
              if (index < 12) {

                if ( ovidata.value === 0 || ovidata.value === 1 || ovidata.value === 2 ) {
                  teamOviFiltered.red[index] = teamOviFiltered.red[index] + 1;
                }

                if (ovidata.value === 3 || ovidata.value === 4) {
                  teamOviFiltered.yellow[index] =
                    teamOviFiltered.yellow[index] + 1;
                }

                if (ovidata.value === 5 || ovidata.value === 6) {
                  teamOviFiltered.green[index] =
                    teamOviFiltered.green[index] + 1;
                }
              }

              return ovidata;
            });

            teamDates.push(allOvi.date);
            
            teamOviSummaryData.push({
              date: allOvi.date,
              ovival: allOvi.ovi_count,
              items: 1,
              ovi_sum: teamOviFiltered
            });

          } else {
            teamOviSummaryData.find((o, i) => {
              if (o.date === allOvi.date) {
                const items = teamOviSummaryData[i].items + 1;
                const oviVal = teamOviSummaryData[i].ovival + allOvi.ovi_count;

                let teamOviFiltered = teamOviSummaryData[i].ovi_sum;

                allOvi.data.map((ovidata, index) => {
                  if (index < 12) {

                    if (
                      ovidata.value === 0 ||
                      ovidata.value === 1 ||
                      ovidata.value === 2
                    ) {
                      teamOviFiltered.red[index] =
                        teamOviFiltered.red[index] + 1;
                    }

                    if (ovidata.value === 3 || ovidata.value === 4) {
                      teamOviFiltered.yellow[index] =
                        teamOviFiltered.yellow[index] + 1;
                    }

                    if (ovidata.value === 5 || ovidata.value === 6) {
                      teamOviFiltered.green[index] =
                        teamOviFiltered.green[index] + 1;
                    }
                  }

                  return ovidata;
                });

                teamOviSummaryData[i].ovival = oviVal;
                teamOviSummaryData[i].items = items;
                teamOviSummaryData[i].ovi_sum = teamOviFiltered;

                return true; // stop searching
              }

              return false;
            });
          }

          return allOvi;
        });
      }

      return userdata;
    });
  }

  const sortedJsObjects = teamOviSummaryData.sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateB - dateA;
  });

  const sortedJsObjectsWeekly = teamOviWeeklySummaryData.sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateB - dateA;
  });

  const teamOviSummaryDataSorted = sortedJsObjects.reverse();
  const teamOviSummaryDataSortedWeekly = sortedJsObjectsWeekly.reverse();
  let teamDatesSorted = [];
  let teamOviSum = [];
  let teamWeeksSorted = [];
  let teamOviSumWeekly = [];

  // Get only items that have been answered by more than 30% of the organization.
  const teamOviSummaryFiltered = [];
  const teamOviSummaryFilteredWeekly = [];

  let membersCount = 0;

  if ( props?.ovi?.members_count ) {
    membersCount = parseInt( props?.ovi?.members_count, 10 );
  }

  teamOviSummaryDataSorted.map((obj) => {
    const fiftytyPercent = membersCount * 0.3;

    if (obj.items > fiftytyPercent) {
      teamOviSummaryFiltered.push(obj);
    }

    return obj;
  });

  teamOviSummaryDataSortedWeekly.map((obj) => {
    const fiftytyPercent = membersCount * 0.3;

    if (obj.items > fiftytyPercent) {
      teamOviSummaryFilteredWeekly.push(obj);
    }

    return obj;
  });

  teamOviSummaryFiltered.map((obj) => {
    if (!teamDatesSorted.includes(obj.date)) {
      teamDatesSorted.push(obj.date);
    }

    const sum = parseInt(obj.ovival / obj.items, 10);
    teamOviSum.push(sum);

    return obj;
  });

  teamOviSummaryFilteredWeekly.map((obj, index ) => {
    
    let weekString = `v${obj.week}`;

    // Include the year in first entry
    if ( index === 0 ) {
      weekString = `${obj.year}-v${obj.week}`;
    }

    if ( index > 0 ) {

      const prevIndex = index - 1;

      if ( teamOviSummaryFilteredWeekly[prevIndex]?.year !== obj.year ) {
        weekString = `${obj.year}-v${obj.week}`;
      }
    }

    if (!teamWeeksSorted.includes(weekString)) {
      teamWeeksSorted.push(weekString);
    }

    const sum = parseInt(obj.ovival / obj.items, 10);
    teamOviSumWeekly.push(sum);

    return obj;
  });

  //console.log( teamWeeksSorted );
  //console.log( teamOviSumWeekly );

  //const sorted = teamOviSummaryData.sort(sortByDate);
  //console.log( sortedJsObjects );

  // teamOviSummaryData.map( (oviData) => {

  // });

  if (props.ovi.organization && props.ovi.organization.length > 0) {
    teamOvi.red.map(
      (ovival, index) =>
        (teamOvi.red[index] = parseInt(
          (ovival * 100) / props.ovi.organization.length,
          10
        ))
    );
    teamOvi.yellow.map(
      (ovival, index) =>
        (teamOvi.yellow[index] = parseInt(
          (ovival * 100) / props.ovi.organization.length,
          10
        ))
    );
    teamOvi.green.map(
      (ovival, index) =>
        (teamOvi.green[index] = parseInt(
          (ovival * 100) / props.ovi.organization.length,
          10
        ))
    );

    teamOviSummaryFiltered.map((summaryItem) => {
      summaryItem.ovi_sum.red.map(
        (ovival, index) =>
          (summaryItem.ovi_sum.red[index] = parseInt(
            (ovival * 100) / summaryItem.items,
            10
          ))
      );
      summaryItem.ovi_sum.yellow.map(
        (ovival, index) =>
          (summaryItem.ovi_sum.yellow[index] = parseInt(
            (ovival * 100) / summaryItem.items,
            10
          ))
      );
      summaryItem.ovi_sum.green.map(
        (ovival, index) =>
          (summaryItem.ovi_sum.green[index] = parseInt(
            (ovival * 100) / summaryItem.items,
            10
          ))
      );

      return summaryItem;
    });

    teamOviSummaryFilteredWeekly.map((summaryItem) => {
      summaryItem.ovi_sum.red.map(
        (ovival, index) =>
          (summaryItem.ovi_sum.red[index] = parseInt(
            (ovival * 100) / summaryItem.items,
            10
          ))
      );
      summaryItem.ovi_sum.yellow.map(
        (ovival, index) =>
          (summaryItem.ovi_sum.yellow[index] = parseInt(
            (ovival * 100) / summaryItem.items,
            10
          ))
      );
      summaryItem.ovi_sum.green.map(
        (ovival, index) =>
          (summaryItem.ovi_sum.green[index] = parseInt(
            (ovival * 100) / summaryItem.items,
            10
          ))
      );

      return summaryItem;
    });
  }

  //const teamOviSummaryFilteredReversed = teamOviSummaryFiltered;
  //console.log( teamOviSummaryData );

  //const datesOriginal = dates;

  let datesMerged = [];
  let datesMergedUniq = [];
  let mergedOviValues = [];
  let mergedTeamOviSum = [];
  let mergedTeamHViData = [];

  if (props.organization) {
    datesMerged = [...dates, ...teamDatesSorted];
    datesMerged = datesMerged.sort();

    datesMergedUniq = [...new Set(datesMerged)];

    if (datesMergedUniq) {
      datesMergedUniq.map((itemDate) => {
        const datesIndex = dates.findIndex((date) => date === itemDate);
        const teamDatesIndex = teamDatesSorted.findIndex(
          (date) => date === itemDate
        );
        const summaryIndex = teamOviSummaryFiltered.findIndex(
          (item) => item.date === itemDate
        );

        if (datesIndex !== -1) {
          mergedOviValues.push(oviValues[datesIndex]);
        } else {
          mergedOviValues.push(null);
        }

        if (teamDatesIndex !== -1) {
          mergedTeamOviSum.push(teamOviSum[teamDatesIndex]);
        } else {
          mergedTeamOviSum.push(null);
        }

        if (summaryIndex !== -1) {
          mergedTeamHViData.push(teamOviSummaryFiltered[summaryIndex]);
        } else {
          mergedTeamHViData.push({});
        }

        return itemDate;
      });

    }
  }

  let recentOviCount = 0;

//   let userRoles = [];

//   if ( props?.roles ) {
//       userRoles = Object.values( props?.roles );
//   }

  if (props.ovi?.personal?.length > 0) {
    let lastIndex = props.ovi?.personal?.length - 1;

    if (!lastIndex || lastIndex < 0) {
      lastIndex = 0;
    }

    const recentOviItem = props.ovi.personal[lastIndex];

    if (recentOviItem) {
      recentOviCount = recentOviItem.ovi_count;
    }
  }

  return (
    <div className="ovi-chart-wrap mt-3">
      <div className="row">
        <div className={`${props?.gtg ? 'col-12 col-lg-6' : 'col-12'}`}>
          {/* <h3 className="border-bottom pb-2 mb-4">HVI</h3> */}

          {props.organization && window.location.pathname !== "/" && (
            <PersonalLinear
              dates={ teamOviSumWeekly.length > 0 ? teamWeeksSorted : datesMergedUniq}
              hviValues={[mergedOviValues, teamOviSumWeekly]}
              loading={props.loading}
              type="team"
              summary={teamOviSummaryFilteredWeekly}
              organization={props.organization}
              title="OWI - Organisation Well function Index"
            />
          )}

          {!props.organization && window.location.pathname !== "/" && (
            <PersonalLinear
              dates={dates}
              hviValues={[oviValues, []]}
              loading={props.loading}
              type="personal"
              organization={props.organization}
            />
          )}

          { window.location.pathname === "/" &&
            <div className="bg-white pt-2 w-100" style={{height: "336px"}}>

              <div className="d-flex flex-column h-100">
                <div className="p-3 pt-0">
                  <div className="d-flex align-items-center">
                    <h5 className="flex-grow-1">Organisation Well function Index</h5>
                    <span className="display-6">{recentOviCount}</span>
                    {/* <Link
                      to={`hvi/?count=${recentHviCount}`}
                      className="text-secondary d-inline-block text-decoration-none"
                    >
                      <span className="pe-2">{translation('view_all_hwi')}</span>
                      <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </Link> */}
                  </div>
                  { oviValues && oviValues.length > 0 &&
                    <p className="opacity-half font-size-medium mb-0 mt-1">Detta test ger dig och er svar på hur välfungerande du och ni tycker att organisationen är.</p>
                  }

                  { oviValues && !oviValues.length > 0 &&
                    <p className="opacity-half font-size-medium mb-0 mt-1 bg-sy-gray text-white p-3 rounded mt-3">{translation('no_hwi_team')}</p>
                  }
                  
                  
                  <div className="d-flex mt-3">
                    <Link to="/ovi/" className="btn btn-secondary rounded-pill font-size-medium me-2" >
                      <span className="pe-2">{translation('go_to_test')}</span>
                      <i className="fa fa-angle-right" aria-hidden="true"></i>
                    </Link>

                    { oviValues && oviValues.length > 0 &&
                      <Link to={`ovi/?count=${recentOviCount}`} className="btn btn-secondary rounded-pill font-size-medium">
                        <span className="pe-2">Se tidigare</span>
                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                      </Link>
                    }

                    
                  </div>

                  {/* <span className="display-1">{recentHviCount}</span> */}
                </div>
                
                { oviValues && oviValues.length > 0 &&
                  <div className="mt-auto">
                    <TeamDataColumnChart data={oviValues}  dates={dates} type="OWI" />
                  </div>
                }
                

              </div>
              
            </div>
          }

          {recentOviCount > 0 && window.location.pathname !== "/" && (
            <div className="text-end">
              <Link
                to={`ovi/?count=${recentOviCount}`}
                className="text-secondary d-inline-block text-decoration-none"
              >
                <span className="pe-2">Visa alla dina OWI</span>
                <i className="fa fa-angle-right" aria-hidden="true"></i>
              </Link>
            </div>
          )}
        </div>

        { props?.gtg &&
            <div className="col-12 col-lg-6">
            {/* <h3 className="border-bottom pb-2 mb-4">Grå till guld</h3> */}
            <GrayToGoldLinear loading={props.loading} />
          </div>
        }

        {/* {props.organization && 
                    
                } */}
      </div>
            
            {props.organization && window.location.pathname !== "/" && teamOviSummaryFilteredWeekly && teamOviSummaryFilteredWeekly.length > 0 &&
              <>
                 <div className="row">
                        <div className="col-12">
                            <div className="d-flex my-4 align-items-center">
                                {/* <h3 className="flex-grow-1">Team HVI</h3> */}
                                <div className="border-top pt-4 w-100">
                                    { teamOviSummaryFilteredWeekly.map( (item, index) => {
                                        let weekString = `v${item.week}`;

                                        // Include the year in first entry
                                        if ( index === 0 ) {
                                          weekString = `${item.year}-v${item.week}`;
                                        }
                                    
                                        if ( index > 0 ) {
                                    
                                          const prevIndex = index - 1;
                                    
                                          if ( teamOviSummaryFilteredWeekly[prevIndex]?.year !== item.year ) {
                                            weekString = `${item.year}-v${item.week}`;
                                          }
                                        }
                                        return (
                                            <button className={`btn btn-small mb-2 rounded-pill ${selectedOviItem === index ? 'btn-halite-blue text-white' : 'btn-white bg-white'} ms-2`} key={index} onClick={ () => setSelectedOviItem(index) }>{weekString}</button>
                                        )
                                    }) }
                                </div>
                            </div>
                        </div>
                  </div>

                  <div className="row mb-4">
                    <div className="col-12 col-lg-6">
                        <OfflineColumnChart totalUsers={teamOviSummaryFilteredWeekly[selectedOviItem].items}
                            title="Team OWI - antal per resultatkategori"
                            data={
                                [
                                teamOviSummaryFilteredWeekly[selectedOviItem].red,
                                teamOviSummaryFilteredWeekly[selectedOviItem].yellow_one,
                                teamOviSummaryFilteredWeekly[selectedOviItem].yellow_two,
                                teamOviSummaryFilteredWeekly[selectedOviItem].green,
                                ]
                            } 
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <OfflinePieChart totalUsers={teamOviSummaryFilteredWeekly[selectedOviItem].items} 
                            title="Team OWI - antal per resultatkategori (procent)"
                            data={
                                [
                                teamOviSummaryFilteredWeekly[selectedOviItem].red,
                                teamOviSummaryFilteredWeekly[selectedOviItem].yellow_one,
                                teamOviSummaryFilteredWeekly[selectedOviItem].yellow_two,
                                teamOviSummaryFilteredWeekly[selectedOviItem].green,
                                ]
                            } 
                        />
                    </div>
                  </div>

                  <div className="row">
                      
                    <div className={`col-12`}>
                      <TeamBars
                        hviValues={teamOviSummaryFilteredWeekly[selectedOviItem].ovi_sum} 
                        loading={props.loading} 
                        title="Team OWI - fördelning per fråga"
                        questions={[
                            'Tydliga visioner och mål',
                            'Bidrar till organisationens resultat',
                            'Prioriterar varje dag',
                            'Tydliga ansvarsområden och mål',
                            'Resurser för arbetsuppgifterna',
                            'Värderingarna är viktiga',
                            'Arbetet är meningsfullt och engagerar',
                            'Tillit till sin chef',
                            'Kollegialt stöd',
                            'Trygg i gruppen och kan vara sig själv',
                            'Hinner genomföra förändringar',
                            'Stort förtroende för ledningen'
                        ]}
                        />
                    </div>

                  </div>
              </>
            }
    </div>
  );
};

export default OviChart;
